<template lang="pug">
  v-container
    v-row
      v-col
        h1.text-center Blog
        Crear_entrada_dialog( :dialog='dialog' @_dialog='val => dialog=val')
        v-fab-transition
          v-btn( dark fixed bottom right @click='limpiar(), dialog=true' fab large ).light-green.accent-4
            v-icon fa-pen
    v-row
      Entrada_item( 
        v-for='entrada,i of registro ' 
        :key='i' 
        :entrada= 'entrada'
        @_dialog='val => dialog=val'
      )
              
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
  export default {
    data: ()=>({
      dialog: false,
    }),
    components: {
      Crear_entrada_dialog: ()=>import('./componentes/crear_entrada_dialog'),
      Entrada_item: ()=>import('./componentes/entrada_item')
    },
    computed: {
      ...mapGetters({
        registro: 'Blog/registro',
      })
    },
    methods: mapActions({
      limpiar: 'Blog/limpiar'
    })
 
  }
</script>